module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.clientLogos) ? _c('section', {
    staticClass: "c-clients"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', {
    staticClass: "c-clients__list"
  }, _vm._l((_vm.clientLogos), function(logo) {
    return (_vm.activeFilter === 'all' ? true : (logo[_vm.activeFilter])) ? _c('li', {
      staticClass: "c-clients__list-item",
      style: ('background-image:url(' + logo.url + ')')
    }) : _vm._e()
  })), _vm._v(" "), (_vm.activeFilter === 'featured') ? _c('div', {
    staticClass: "container"
  }, [_c('a', {
    staticClass: "btn-clients",
    on: {
      "click": _vm.showAllClients
    }
  }, [_vm._v(_vm._s(_vm.localizedMoreClientsButtonText))])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d75fb4ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Clients.vue
// module id = 280
// module chunks = 0